export default "__VITE_ASSET__DGA6yxBZ__"